import styles from './Background.scss';

const Background = () => {
  return <div className={styles.background} />;
};

export default Background;
